import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65f94f86"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-asterisk me-2" }, null, -1))
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-md-6" }, " ", -1))
const _hoisted_4 = { class: "col-sm-12 col-md-6" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-auto col-form-label m-0 p-0" }, "ค้นหา:", -1))
const _hoisted_7 = { class: "col" }
const _hoisted_8 = {
  key: 0,
  class: "card card-empty my-2"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body d-flex justify-content-center align-items-center text-danger" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }),
  /*#__PURE__*/_createTextVNode("ไม่พบข้อมูล ")
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "card-header d-flex justify-content-between" }
const _hoisted_12 = { class: "text-truncate" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-tasks me-2" }, null, -1))
const _hoisted_14 = { class: "card-action float-end" }
const _hoisted_15 = { class: "btn-group" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "memo-edit-btn",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cog me-2" }),
  /*#__PURE__*/_createTextVNode("จัดการข้อมูล ")
], -1))
const _hoisted_17 = { class: "dropdown-menu" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-edit me-2" }, null, -1))
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-pen me-2" }, null, -1))
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "#"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }),
  /*#__PURE__*/_createTextVNode("จัดการเอกสารแนบ ")
], -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "#"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-image me-2" }),
  /*#__PURE__*/_createTextVNode("จัดการรูปภาพประกอบ ")
], -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "card-body" }
const _hoisted_33 = {
  key: 0,
  class: "table mb-0"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, "วันที่:", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "รายละเอียด:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "สถานที่:", -1))
const _hoisted_37 = ["href"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-map me-2" }, null, -1))
const _hoisted_39 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "เอกสารแนบ:", -1))
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }, null, -1))
const _hoisted_43 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_44 = {
  key: 1,
  class: "memo d-flex justify-content-center align-items-center"
}
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-clipboard-list me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_PaginateComponent = _resolveComponent("PaginateComponent")!
  const _component_ActivityAttachmentOffcanvasConponent = _resolveComponent("ActivityAttachmentOffcanvasConponent")!
  const _component_ActivityMemoFormComponent = _resolveComponent("ActivityMemoFormComponent")!
  const _component_ActivityMemoResultFormComponent = _resolveComponent("ActivityMemoResultFormComponent")!
  const _component_ActivityAttachmentFileModalComponent = _resolveComponent("ActivityAttachmentFileModalComponent")!
  const _component_ActivityAttachmentUploadModalComponent = _resolveComponent("ActivityAttachmentUploadModalComponent")!
  const _component_ActivityAttachmentImageModalComponent = _resolveComponent("ActivityAttachmentImageModalComponent")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "btn btn-primary mb-3",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createClick && _ctx.createClick(...args)))
    }, [
      _hoisted_1,
      _createTextVNode("เพิ่มการปฏิบัติราชการ ")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "aria-label": "Search",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter.keyword) = $event))
            }, null, 512), [
              [
                _vModelText,
                _ctx.filter.keyword,
                void 0,
                { trim: true }
              ]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.display.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.display, (activityMemo, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "card card-memo my-2"
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createTextVNode(_toDisplayString(activityMemo.subject), 1)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("ul", _hoisted_17, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                href: "#",
                                onClick: _withModifiers(($event: any) => (_ctx.editClick(activityMemo.id)), ["stop","prevent"])
                              }, [
                                _hoisted_19,
                                _createTextVNode("แก้ไขการปฏิบัติราชการ ")
                              ], 8, _hoisted_18)
                            ]),
                            (activityMemo.result)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_20, _hoisted_22))
                              : _createCommentVNode("", true),
                            (activityMemo.result)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    href: "#",
                                    onClick: _withModifiers(($event: any) => (_ctx.resultClick(activityMemo.id)), ["stop","prevent"])
                                  }, [
                                    _hoisted_25,
                                    _createTextVNode("แก้ไขผลการปฏิบัติราชการ ")
                                  ], 8, _hoisted_24)
                                ]))
                              : _createCommentVNode("", true),
                            (activityMemo.result)
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 2,
                                  onClick: _withModifiers(($event: any) => (_ctx.attachmentFileClick(activityMemo.id)), ["stop","prevent"])
                                }, _hoisted_28, 8, _hoisted_26))
                              : _createCommentVNode("", true),
                            (activityMemo.result)
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 3,
                                  onClick: _withModifiers(($event: any) => (_ctx.attachmentImageClick(activityMemo.id)), ["stop","prevent"])
                                }, _hoisted_31, 8, _hoisted_29))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      (activityMemo.result)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_33, [
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _hoisted_34,
                                _createElementVNode("td", null, _toDisplayString(activityMemo?.result.activityDate.toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' })), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_35,
                                _withDirectives(_createElementVNode("td", null, null, 512), [
                                  [_directive_dompurify_html, activityMemo?.result?.description?.replace(/(?:\r\n|\r|\n)/g, '<br />')]
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_36,
                                _createElementVNode("td", null, [
                                  (activityMemo?.result.location)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: `https://maps.google.com/?q=${activityMemo?.result.location.latitude},${activityMemo?.result.location.longitude}`,
                                        target: "_blank"
                                      }, [
                                        _hoisted_38,
                                        _createTextVNode("ดูแผนที่ ")
                                      ], 8, _hoisted_37))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_39, "ไม่ระบุ"))
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_40,
                                _createElementVNode("td", null, [
                                  (activityMemo?.result.attachments.length !== 0)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: "#",
                                        onClick: _withModifiers(($event: any) => (_ctx.showAttachment(activityMemo?.result.attachments)), ["stop","prevent"])
                                      }, [
                                        _hoisted_42,
                                        _createTextVNode("ดูเอกสารแนบ ")
                                      ], 8, _hoisted_41))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_43, "ไม่มีข้อมูล"))
                                ])
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _createElementVNode("button", {
                              class: "btn btn-primary",
                              onClick: ($event: any) => (_ctx.resultClick(activityMemo.id))
                            }, [
                              _hoisted_46,
                              _createTextVNode("รายงานผลการปฏิบัติราชการ ")
                            ], 8, _hoisted_45)
                          ]))
                    ])
                  ]))
                }), 128))
          ], 64))
    ]),
    _createVNode(_component_PaginateComponent, {
      "page-size": _ctx.page.size,
      amount: _ctx.filter.amount,
      total: _ctx.filter.total,
      onCurrentPageChange: _ctx.selectedPage
    }, null, 8, ["page-size", "amount", "total", "onCurrentPageChange"]),
    _createVNode(_component_ActivityAttachmentOffcanvasConponent, {
      ref: "activityAttachmentOffcanvas",
      attachments: _ctx.activityAttachments
    }, null, 8, ["attachments"]),
    _createVNode(_component_ActivityMemoFormComponent, {
      ref: "activityMemoForm",
      "activity-id": _ctx.activityId,
      "province-id": _ctx.provinceId,
      "activity-memo-id": _ctx.activityMemoId
    }, null, 8, ["activity-id", "province-id", "activity-memo-id"]),
    _createVNode(_component_ActivityMemoResultFormComponent, {
      ref: "activityMemoResultForm",
      "activity-id": _ctx.activityId,
      "province-id": _ctx.provinceId,
      "activity-memo-id": _ctx.activityMemoId
    }, null, 8, ["activity-id", "province-id", "activity-memo-id"]),
    _createVNode(_component_ActivityAttachmentFileModalComponent, {
      ref: "activityAttachmentFileModal",
      "activity-id": _ctx.activityId,
      "province-id": _ctx.provinceId,
      "activity-memo-id": _ctx.activityMemoId,
      onUpload: _ctx.handleUpload
    }, null, 8, ["activity-id", "province-id", "activity-memo-id", "onUpload"]),
    _createVNode(_component_ActivityAttachmentUploadModalComponent, {
      ref: "activityAttachmentUploadModal",
      "activity-id": _ctx.activityId,
      "province-id": _ctx.provinceId,
      "activity-memo-id": _ctx.activityMemoId,
      onHidden: _ctx.handleHidden
    }, null, 8, ["activity-id", "province-id", "activity-memo-id", "onHidden"]),
    _createVNode(_component_ActivityAttachmentImageModalComponent, {
      ref: "activityAttachmentImageModal",
      "activity-id": _ctx.activityId,
      "province-id": _ctx.provinceId,
      "activity-memo-id": _ctx.activityMemoId
    }, null, 8, ["activity-id", "province-id", "activity-memo-id"])
  ], 64))
}